/* eslint-disable indent */
/*
 * @Descripttion:
 * @version:
 * @Author: 李昭
 * @Date: 2020-07-06 15:06:44
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-03-22 20:16:42
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import store from '@/store'
import AMap from 'vue-amap'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import meetingIm from 'vue-nim-video'
import shigongbang from '@/utils/index.js'
//导入申请邀请侧边栏
import JoinDialog from 'vue-join-dialog'
import './static/css/flex.css'

import './assets/icon/iconfont.css'
import * as filters from './filters'
import * as filtersZhaoCai from './filters/zhaocai'
import directives from '@/directives' // 自定义指令
import '@/directives/permission/index.js' // 权限校验指令和全局方法
import '@/static/css/quill.bubble.css'
import '@/static/css/quill.core.css'
import '@/static/css/quill.snow.css'
//工程分包所需的公共方法
import global from "./mixins/global";
Vue.mixin(global)
/**
 * @name: 下面这段代码为了防止高德地图刷新报错,勿删
 */

// eslint-disable-next-line indent
Object.keys(filtersZhaoCai).forEach(key => {
  // eslint-disable-next-line indent
  Vue.filter(key, filtersZhaoCai[key])
})

// // vuex注册会议
meetingIm.mergeStore(store, router) //vuex 注册会议模块
Vue.use(meetingIm)
Vue.use(JoinDialog)

//im更新
import KfClient from 'zj-plugin-kf-client'
Vue.use(KfClient, { store })  // 注册

// let len = localStorage.length // 获取长度
// let arr = []
// for (let i = 0; i < len; i++) {
//   // 获取key 索引从0开始
//   let getKey = localStorage.key(i)
//   arr.push(getKey)
// }
// arr.forEach(item => {
//   // 删除以_AMap开头的key
//   if (item && item.indexOf('_AMap') !== -1) {
//     localStorage.removeItem(item)
//   }
// })
Vue.use(AMap)
// import preview from 'vue-photo-preview'
// import 'vue-photo-preview/dist/skin.css'
// Vue.use(preview)

// D:\git\engineering_team\src\assets\icon\iconfont.css
// Vue.use(common)
ElementUI.Table.props.headerCellStyle.default={background:'#FAFAFA',color:'#333333'}
Vue.use(ElementUI)
Vue.use(shigongbang)

import '@/components/ui-components' //全局自定义UI

//关注提示
import showToast from '@/components/toast'
Vue.use(showToast)

// 权限提示弹窗
import showPermissionTips from '@/components/permissionModal'
Vue.use(showPermissionTips)

import infiniteScroll from 'vue-infinite-scroll'
Vue.use(infiniteScroll)

AMap.initAMapApiLoader({
  // 高德key
  key: 'd06ecdcdbaf5643b02949b50c540628b',
  // 插件集合 （插件按需引入）
  plugin: ['Autocomplete', 'PlaceSearch', 'Scale', 'OverView', 'ToolBar', 'MapType', 'PolyEditor', 'AMap.CircleEditor', 'AMap.Geocoder', 'AMap.Geolocation'],
  v: '1.4.4'
})
//Vue.prototype.$imSDKStore = store.state.zjtech
Vue.config.productionTip = false
Vue.prototype.ossUrl = process.env.VUE_APP_File_API
Vue.prototype._updataTime = function (time) {
  return time.getFullYear() + '-' + (time.getMonth() + 1) + '-' + time.getDate()
}
Vue.prototype.dateFormat = function (time) { // 处理13位
  const times = new Date(time)
  let y = times.getFullYear()
  let m = times.getMonth() + 1
  m = m < 10 ? ('0' + m) : m
  let d = times.getDate()
  d = d < 10 ? ('0' + d) : d
  // let h = times.getHours();
  // h = h < 10 ? ('0' + h) : h;
  // let minute = times.getMinutes();
  // let second = times.getSeconds();
  // minute = minute < 10 ? ('0' + minute) : minute;
  // second = second < 10 ? ('0' + second) : second;
  const data = y + '-' + m + '-' + d
  return data
}
Vue.prototype.starPhone = function (phoneNum) {
  let str = String(phoneNum)
  return str.substr(0, 3) + '****' + str.substr(7)
},


  // eslint-disable-next-line indent
  Object.keys(filters).forEach(key => {
    // eslint-disable-next-line indent
    Vue.filter(key, filters[key])
  })

  initErrorReportForVue(Vue, '工程工队')

// 百度统计
const _hmt = _hmt || []
window._hmt = _hmt; // 必须把_hmt挂载到window下，否则找不到
(function () {
  let hm = document.createElement('script')
  hm.src = 'https://hm.baidu.com/hm.js?9c658e405f21825d1398173a890581b0'
  let s = document.getElementsByTagName('script')[0]
  s.parentNode.insertBefore(hm, s)
})()

// 骨架屏
const runtime = require('offline-plugin/runtime');
runtime.install({
  onUpdating: () => {
    console.log('SW Event:', 'onUpdating');
  },
  onUpdateReady: () => {
    console.log('SW Event:', 'onUpdateReady');
    // Tells to new SW to take control immediately
    runtime.applyUpdate();
  },
  onUpdated: () => {
    console.log('SW Event:', 'onUpdated');
    // Reload the webpage to load into the new version
    // window.location.reload();
  },

  onUpdateFailed: () => {
    console.log('SW Event:', 'onUpdateFailed');
  }
});

const vue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
//窗口中挂载vue,在store中调用
window._vue=vue;
export default vue
